import { render, staticRenderFns } from "./ReviewListItem.vue?vue&type=template&id=832192a4&scoped=true"
import script from "./ReviewListItem.vue?vue&type=script&lang=js"
export * from "./ReviewListItem.vue?vue&type=script&lang=js"
import style0 from "./ReviewListItem.vue?vue&type=style&index=0&id=832192a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "832192a4",
  null
  
)

export default component.exports